import { apiFetcher } from '@gjensidige/service-async';
import { GjeRequestInit } from '@gjensidige/service-async/lib/types/types';

import {
  getElibilityCheckResponse,
  getPropertyDataMockedResponse
} from '../mock-data/app-calculation-se-api-mock';
import { API_ENDPOINTS } from './constant';
import { PropertyResponseType } from './types';

const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

export const checkEligibility = async (cpr: string) => {
  if (process.env.NODE_ENV !== 'production') {
    await delay(500);
    return getElibilityCheckResponse;
  }

  const request: GjeRequestInit = {
    cache: 'no-cache',
    headers: {
      Applikasjon: 'GFSEWEBSHOP'
    },
    body: {
      channel: 'gjensidige',
      cpr: cpr,
      product: 'villa-home'
    }
  };

  const response = await apiFetcher.postJson<any>(
    API_ENDPOINTS.eligibilityCheck,
    request
  );
  if (response.isOk()) {
    return response.value;
  }
  return {
    error: true
  };
};

export const fetchPropertyData = async (
  isProperty: boolean,
  propertyQuery: string
) => {
  const keyType = isProperty ? 'P' : 'A';
  const encodedPropertyQuery = encodeURI(propertyQuery);
  const url = `${API_ENDPOINTS.getPropertyData}/keyType/${keyType}/propertyKey/${encodedPropertyQuery}`;
  if (process.env.NODE_ENV !== 'production') {
    await delay(1000);
    return getPropertyDataMockedResponse;
  }
  const response = await apiFetcher.getJson<PropertyResponseType>(url, {
    cache: 'no-cache',
    headers: {
      Applikasjon: 'GFSEWEBSHOP'
    }
  });
  if (response.isOk()) {
    return response.value;
  }
  return {
    propertyDataList: [],
    calculationStatus: {
      error: true
    }
  };
};
